function readQuoteNumber(quote: Record<string, unknown>, key: string): number | null {
  const value = quote[key];
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string") {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

function readQuoteTime(quote: Record<string, unknown>, key: string): number {
  const value = quote[key];
  if (typeof value !== "string" || !value) return 0;
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : 0;
}

/** Pick the most recent RH trade price (regular or extended hours). */
export function parseRhEquityQuotePrice(entry: unknown): number | null {
  if (!entry || typeof entry !== "object" || Array.isArray(entry)) return null;
  const quote = (entry as { quote?: unknown }).quote;
  if (!quote || typeof quote !== "object" || Array.isArray(quote)) return null;
  const q = quote as Record<string, unknown>;
  const reg = readQuoteNumber(q, "last_trade_price");
  const ext = readQuoteNumber(q, "last_non_reg_trade_price");
  const regAt = readQuoteTime(q, "venue_last_trade_time");
  const extAt = readQuoteTime(q, "venue_last_non_reg_trade_time");
  if (reg != null && ext != null) {
    if (extAt > regAt) return ext;
    if (regAt > extAt) return reg;
    return ext;
  }
  return ext ?? reg;
}

export function parseRhEquityQuoteMap(results: unknown): Map<string, number> {
  const map = new Map<string, number>();
  if (!Array.isArray(results)) return map;
  for (const entry of results) {
    if (!entry || typeof entry !== "object" || Array.isArray(entry)) continue;
    const symbolRaw = (entry as { quote?: { symbol?: unknown } }).quote?.symbol;
    const symbol = typeof symbolRaw === "string" ? symbolRaw.trim().toUpperCase() : "";
    const price = parseRhEquityQuotePrice(entry);
    if (symbol && price != null) map.set(symbol, price);
  }
  return map;
}
